<template>
	<div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Penugasan</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Penugasan Bimbel</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">

					<div class="row">
						
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<Sidebar />
						</div>
						<!-- / Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">
							<div class="card">
								<div class="card-body pt-0">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#pat_medical_records" data-toggle="tab"><span class="med-records">Penugasan Bimbel</span></a>
											</li>
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
											 
										<!-- Course Records Tab -->
										<div id="pat_medical_records" class="tab-pane fade show active">
											<div class="card card-table mb-0">
												<div class="card-body">
													
													<div class="table-responsive">
														<table id="tbl" class="table table-hover table-center mb-0">
															<thead>
                                                                <tr>
                                                                    <th rowspan="2">ID</th>
																	<th rowspan="2">Nama Paket</th>
                                                                    <th rowspan="2">Judul</th>
                                                                    <th rowspan="2">Jadwal</th>
                                                                    <th rowspan="2">Nama Coach</th>
                                                                    <th colspan="3">Link</th>
                                                                    <th rowspan="2">Status</th>
                                                                    <th rowspan="2">Aksi</th>
                                                                </tr> 
                                                                <tr>										
                                                                    <th>Pertemuan</th>
                                                                    <th>Rekaman</th>
                                                                    <th>Materi</th>
                                                                </tr>     
															</thead>                                                            
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstjadwal" :key="ref">
                                                                    <td class="text-center">{{ index + 1 }}</td>
                                                                    <td>{{ref.nama_paket}}</td>										
                                                                    <td>{{ref.judul_pertemuan}}</td>										
                                                                    <td>{{ref.jadwal_pertemuan_lbl}}</td>										
                                                                    <td>{{ref.nama_coach2}}</td>	
                                                                    <td class="text-center">
                                                                        <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.link_pertemuan == '-' , 'bg-success-light' : ref.link_pertemuan != '-'}"><i :class="{'fas': true, 'fa-times' : ref.link_pertemuan == '-' , 'fa-check' : ref.link_pertemuan != '-'}"></i></span>
                                                                    </td>
                                                                    <td class="text-center">
                                                                        <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.link_rekaman == '-' , 'bg-success-light' : ref.link_rekaman != '-'}"><i :class="{'fas': true, 'fa-times' : ref.link_rekaman == '-' , 'fa-check' : ref.link_rekaman != '-'}"></i></span>
                                                                    </td>	
                                                                    <td class="text-center">
                                                                        <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.link_materi == '-' , 'bg-success-light' : ref.link_materi != '-'}"><i :class="{'fas': true, 'fa-times' : ref.link_materi == '-' , 'fa-check' : ref.link_materi != '-'}"></i></span>
                                                                    </td>											
                                                                    <td class="text-center">{{ref.status_lbl}} 
                                                                    </td>	
                                                                    <td class="text-center">
                                                                        <v-btn color="btn btn-xs bg-info-light" depressed small @click="editJadwal(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn v-if="ref.status_jadwal=='0'" color="btn btn-xs bg-warning-light" depressed small @click="getLdtSiswa(ref)">
                                                                            <i class="fas fa-files"></i> #LDT
                                                                        </v-btn>
                                                                        
                                                                    </td>
                                                                </tr>                                                                
                                                            </tbody>  	
														</table>
													</div>
												</div>
											</div>
										</div>
										<!-- /Course Records Tab -->
										
										
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		</div>
		
		<div id="jadwalMdl" class="modal custom-modal fade" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-xl" role="document" style="width:90% !important">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Penugasan</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<form id="frm">                            
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Judul Pertemuan</label>
                                        <input class="form-control" type="text" v-model="paketjadwal.judul_pertemuan" readonly>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Jadwal Pertemuan</label>
                                        <input class="form-control" type="datetime-local" v-model="paketjadwal.jadwal_pertemuan" readonly>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Link Pertemuan</label>
                                        <input class="form-control" type="text" v-model="paketjadwal.link_pertemuan" readonly>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Link Rekaman</label>
                                        <input class="form-control" type="text" v-model="paketjadwal.link_rekaman" readonly>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Link Materi</label>
                                        <input class="form-control" type="text" v-model="paketjadwal.link_materi" readonly>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
										<label>Status</label>
										<v-select
										:options="lststs"
										:reduce="lststs => lststs.id" 
										label="text"
										v-model="paketjadwal.status_jadwal"
                                        disabled
										/>
										
									</div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Pre Test</label>
                                        <v-select
                                        :options="lsttryoutjadwal"
                                        :reduce="lsttryoutjadwal => lsttryoutjadwal.id_to" 
                                        label="nama_to"
                                        v-model="paketjadwal.pretest"
                                        />                                        
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Post Test</label>
                                        <v-select
                                        :options="lsttryoutjadwal"
                                        :reduce="lsttryoutjadwal => lsttryoutjadwal.id_to" 
                                        label="nama_to"
                                        v-model="paketjadwal.posttest"
                                        />
                                        
                                    </div>
                                </div>
								
                            </div>
                            <div class="submit-section text-center">
                                <button class="btn btn-info btn-sm" @click.prevent="saveJadwal">Simpan</button>
                                <!-- <button class="btn btn-danger btn-sm" @click.prevent="resetJadwal">Reset</button> -->
                            </div>
							<hr>

                        </form>

						
					</div>
					<!-- <div class="modal-footer">
						<div class="submit-section text-center">
							<button class="btn btn-primary submit-btn" @click.prevent="saveJadwal">Simpan Jadwal</button>
						</div>
					</div> -->
				</div>
			</div>
		</div>

		
        <div id="ldtMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl"  role="document" style="width:90% !important">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">LearnDoTeach</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
						
						<div class="card card-table">
							<div class="card-body p-3">
                                <table class="table table-nobordered table-center mb-0">
                                    <thead>
                                        <tr>
                                            <th width="20%">Nama Paket</th>
                                            <th>:</th>
                                            <th>{{paketjadwal.nama_paket}}</th>
                                        </tr>
                                        <tr>
                                            <th>Judul Pertemuan</th>
                                            <th>:</th>
                                            <th>{{paketjadwal.judul_pertemuan}}</th>
                                        </tr>
                                    </thead>
                                </table>
                                <!-- <h4 class="modal-title">Judul Pertemuan : {{paketjadwal.judul_pertemuan}} </h4> -->
                                
								<!-- <div class="row text-center">
									<div class="col-md-6">
										<div class="form-group card-label">
											<label>Paket Bimbel : {{paketjadwal.judul_pertemuan}}</label>
											
										</div>
									</div>
								</div> -->
							</div>
						</div>

						<div class="card card-table mb-0">
							<div class="card-body">
								
								<div class="table-responsive">
									<table id="tblLdt" class="table table-hover table-center mb-0">
										<thead>
											<tr>
												<th class="text-left">#</th>
												<!-- <th class="text-left">Paket Bimbel</th> -->
												<th class="text-left">Nama Peserta</th>
												<th class="text-left">Jumlah Soal</th>
												<th class="text-left">Action</th>
											</tr>
										</thead>
					
										<tbody>
											
											<tr v-for="(ref, index) in lstldtsiswa" :key="ref.id_to">
												<td>{{ index + 1 }}</td>
												<!-- <td>{{ ref.nama_paket }}</td> -->
												<td>{{ ref.namauser }}</td>
												<td class="text-center">{{ ref.jumlah_soal }}</td>
												<td>
													<v-btn class="btn btn-sm bg-warning-light" depressed small @click="getPreview(ref)">
														<i class="fas fa-eye"></i> Preview Soal
													</v-btn>
												</td>
											</tr>
										</tbody>                                            
									</table>
									
								</div>
							</div>
						</div>
						<br><hr><br>
                       <div class="row" v-if="lstsoal.length">
						    <br><br>
                            <div class="comp-header p-3"><h3 class="comp-title">Peserta {{ldt.namauser}}</h3> <div class="line"></div></div>

                            <div class="col-md-12" v-for="(ref, index) in lstsoal" :key="ref.soal.id_soal">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="login-header">
                                            <h3>Soal Nomor {{index+1}}
                                                <!-- <button v-if="ref.soal.ket_laporan" class="btn btn-rounded float-right" :class="{'btn-outline-danger': !ref.soal.ket_laporan, 'btn-outline-warning': ref.soal.ket_laporan}" @click="getLaporan()"><i class="fa fa-info-circle"></i> {{ref.soal.ket_laporan ? "Lihat laporan soal":""}} </button> -->
                                            </h3>
                                        </div>
                                    </div>
                                    <!-- Checkout Form -->
                                    <div class="card-body">
                                
                                        <!-- Personal Information -->
                                        <div class="info-widget">

                                            <div class="row">
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="titleContainer title " v-html="ref.soal.uraian_soal"></div>

                                                    <!-- quizOptions -->
                                                    <div class="optionContainer">
                                                    <!-- <tr v-for="(opsi,i) in this.list_jawaban" :key="opsi.id_jawaban"> -->

                                                        <div class="option" v-for="(response, idx) in ref.list_jawaban" :key="idx"
                                                       
                                                        :class="{ 'bg-info-light': (response.poin >0)}">
                                                            {{ response.jawaban }}. {{ response.uraian_jawaban }}
                                                            <button class="float-right">
                                                                <span >Poin Jawaban : {{response.poin}}</span> &nbsp;
                                                                <i class="fa" 
                                                                :class="{'fa-check':response.poin > 0}"
                                                                ></i> </button>
                                                            
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            
                                        </div>

                                        <div>
                                            <div class="login-header">
                                                    <h3>Pembahasan</h3>
                                            </div>
                                            <div class="alert alert-warning " v-html="ref.soal.pembahasan"></div>

                                            <!-- <button class="btn btn-rounded btn-outline-primary" @click.prevent="selectOption(-1)">Kosongkan Jawaban</button> -->
                                        </div>
                                    </div>
                                    <!-- /Checkout Form -->
                                </div>
                                
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>

        		
        <div id="ldtMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl"  role="document" style="width:90% !important">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">LearnDoTeach | Paket {{paket.nama_paket}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
						
						<div class="card card-table">
							<div class="card-body p-3">
								<div class="row text-center">
									<div class="col-md-6">
										<div class="form-group card-label">
											<!-- <label>Paket Bimbel</label> -->
											<v-select
											:options="lstjadwal"
											:reduce="lstjadwal => lstjadwal.id_paket_jadwal" 
											label="judul_pertemuan"
											v-model="id_paket_jadwal"
											placeholder="Silahkan pilih Jadwal Pertemuan"
											required
											/>
											
										</div>
									</div>
									<div class="col-md-3 ">
										<button class="btn btn-primary btn-sm float-left" @click.prevent="getLdtSiswa()"> Lihat Hasil LearnDiTeach </button>
									</div>
								</div>
							</div>
						</div>

						<div class="card card-table mb-0">
							<div class="card-body">
								
								<div class="table-responsive">
									<table id="tblLdt" class="table table-hover table-center mb-0">
										<thead>
											<tr>
												<th class="text-left">#</th>
												<!-- <th class="text-left">Paket Bimbel</th> -->
												<th class="text-left">Nama Peserta</th>
												<th class="text-left">Jumlah Soal</th>
												<th class="text-left">Action</th>
											</tr>
										</thead>
					
										<tbody>
											
											<tr v-for="(ref, index) in lstldtsiswa" :key="ref.id_to">
												<td>{{ index + 1 }}</td>
												<!-- <td>{{ ref.nama_paket }}</td> -->
												<td>{{ ref.namauser }}</td>
												<td class="text-center">{{ ref.jumlah_soal }}</td>
												<td>
													<v-btn class="btn btn-sm bg-warning-light" depressed small @click="getPreview(ref)">
														<i class="fas fa-eye"></i> Preview Soal
													</v-btn>
												</td>
											</tr>
										</tbody>                                            
									</table>
									
								</div>
							</div>
						</div>
						<br><hr><br>
                       <div class="row" v-if="lstsoal.length">
						    <br><br>
                            <div class="comp-header p-3"><h3 class="comp-title">LearnDoTeach | Peserta {{ldt.namauser}}</h3> <div class="line"></div></div>

                            <div class="col-md-12" v-for="(ref, index) in lstsoal" :key="ref.soal.id_soal">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="login-header">
                                            <h3>Soal Nomor {{index+1}}
                                                <!-- <button v-if="ref.soal.ket_laporan" class="btn btn-rounded float-right" :class="{'btn-outline-danger': !ref.soal.ket_laporan, 'btn-outline-warning': ref.soal.ket_laporan}" @click="getLaporan()"><i class="fa fa-info-circle"></i> {{ref.soal.ket_laporan ? "Lihat laporan soal":""}} </button> -->
                                            </h3>
                                        </div>
                                    </div>
                                    <!-- Checkout Form -->
                                    <div class="card-body">
                                
                                        <!-- Personal Information -->
                                        <div class="info-widget">

                                            <div class="row">
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="titleContainer title " v-html="ref.soal.uraian_soal"></div>

                                                    <!-- quizOptions -->
                                                    <div class="optionContainer">
                                                    <!-- <tr v-for="(opsi,i) in this.list_jawaban" :key="opsi.id_jawaban"> -->

                                                        <div class="option" v-for="(response, idx) in ref.list_jawaban" :key="idx"
                                                       
                                                        :class="{ 'bg-info-light': (response.poin >0)}">
                                                            {{ response.jawaban }}. {{ response.uraian_jawaban }}
                                                            <button class="float-right">
                                                                <span >Poin Jawaban : {{response.poin}}</span> &nbsp;
                                                                <i class="fa" 
                                                                :class="{'fa-check':response.poin > 0}"
                                                                ></i> </button>
                                                            
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            
                                        </div>

                                        <div>
                                            <div class="login-header">
                                                    <h3>Pembahasan</h3>
                                            </div>
                                            <div class="alert alert-warning " v-html="ref.soal.pembahasan"></div>

                                            <!-- <button class="btn btn-rounded btn-outline-primary" @click.prevent="selectOption(-1)">Kosongkan Jawaban</button> -->
                                        </div>
                                    </div>
                                    <!-- /Checkout Form -->
                                </div>
                                
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>


	</div>
		<!-- /Main Wrapper -->
</template>


<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'
import Number  from 'vue-number-format'

export default {
    components: {
        Sidebar, Number
    },
	name: 'bimbel',
    data() {
        return {
			number: {
				decimal: '.',
				separator: ',',
				prefix: 'I ',
				// suffix: ' #',
				precision: 0,
				masked: false
			},
            lstpaket: [],
            paket:{
                id_paket: '',
                nama_paket: '',
                tipe_paket: '',
                harga_awal: 0,
                diskon: '',
				harga_aktif: '',
                masa_berlaku: '',
				jml_to: '',
                diskon_referral: '',
                komisi_referral: '',
                url_gambar: '',
                fg_publish: '',
                fg_pendaftaran: '',
                fg_favorit: '',
                url_telegram: '',
                slot: '',
				deskripsi: ''
            },			
            lststs: [
                {id: '0', text: 'OPEN'},
                {id: '1', text: 'CLOSED'}
            ],
            lsttipe: [
                {id: '1', text: 'MANDIRI'},
                {id: '2', text: 'BIMBEL'}
            ],
            lststspublish: [
                {id: '1', text: 'DRAFT'},
                {id: '2', text: 'PUBLISH'}
            ],
			lstjadwal: [],
			lsttryout: [],
			paketlsttryout: [],
			lstmateri: [],
			paketlstmateri: [],
			paketjadwal:{
                id_paket:'',
				id_paket_jadwal: '',
                judul_pertemuan: '',
                jadwal_pertemuan: '',
                nama_coac: '',
                link_pertemuan: '',
                link_rekaman: '',
				link_materi: '',
                pretest: '',
				posttest: '',
				status_jadwal: '',
				id_coach: localStorage.getItem('idUser')
            },
			refpaketjadwal:{
                id_paket:'',
				id_paket_jadwal: '',
                judul_pertemuan: '',
                jadwal_pertemuan: '',
                nama_coac: '',
                link_pertemuan: '',
                link_rekaman: '',
				link_materi: '',
                pretest: '',
				posttest: '',
				status_jadwal: 0,
				id_coach: ''
            },
			isFormJadwal: false,
			lsttryoutjadwal: [],
			id_paket_jadwal:"",
			lstldtsiswa: [],
			lstsoal: [],
			ldt: [],
			nama_user:"",
			lstcoach: [],
        }
    },
    created: function () {
        this.getAll();
		this.getAllTryoutJadwal();
    },  

    methods: {		
		stripTheGarbage(e) {
			if (e.keyCode < 48 && e.keyCode !== 46 || e.keyCode > 59) {
				e.preventDefault()
			}
		},
		
		initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 8,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,
					"bSort": false

                });
               }, 300)
        },

        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        reloadTbl(tbId){

            // dT.destroy();
            $('#'+tbId).DataTable();
            $('#'+tbId).destroy();
            this.initDt('#'+tbId);
            // $('#'+tbId).ajax.reload();
        },

        // Get Product
        getAll: function () {
            axios.get('api/penugasancoach')
                .then(res => {
                    this.clearTbl("tbl");
                    this.lstjadwal = res.data.data;
                    this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		getEditPaket: function (id_paket) {
            axios.get('api/paket/'+id_paket)
                .then(res => {
                    // console.log(res.data);
                    // this.clearTbl("tbl");

                    this.paket = res.data.data;

					// if(this.paket.list_benefit.length) this.lstbenefit = this.paket.list_benefit;
					// else this.lstbenefit = [];
					
					this.clearTbl("tblJadwal");
					if(this.paket.list_jadwal.length) this.lstjadwal = this.paket.list_jadwal;
					else this.lstjadwal = [];
                    this.initDt("tblJadwal");
					
					// this.clearTbl("tblToPaket");
					// if(this.paket.list_tryout.length) this.paketlsttryout = this.paket.list_tryout;
					// else this.paketlsttryout = [];
					// this.initDt("tblToPaket");
					
					// this.clearTbl("tblKategoriPaket");
					// if(this.paket.list_materi.length) this.paketlstmateri = this.paket.list_materi;
					// else this.paketlstmateri = [];
					// this.initDt("tblKategoriPaket");
					
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 		
		resetJadwal: function () {
			this.paketjadwal = [];
			this.isFormJadwal = false;
		},
		
		addJadwal: function () {
			this.paketjadwal = this.refpaketjadwal;
			this.isFormJadwal = true;
		},

		editJadwal: function (ref) {
			this.paketjadwal = ref;
            $("#jadwalMdl").modal('show');
			// this.isFormJadwal = true;

		},

		closedJadwal: function (ref, status) {
			axios.post('api/paketjadwalstatus', {
                    id_paket: this.paket.id_paket,
					id_paket_jadwal: ref.id_paket_jadwal,
					status_jadwal: status
                })
                .then(res => {
                    // handle success
					this.clearTbl("tblJadwal");
					this.getEditPaket(this.paket.id_paket);
                    this.initDt("tblJadwal");
					this.isFormJadwal = false;
					this.paketjadwal = [];
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
		},

		deleteJadwal: function (ref, index) {

			swal.fire({
				title: "Hapus Jadwal Paket?",
				text: "Apakah anda yakin akan menghapus jadwal ini?",
				icon: "warning",
				buttons: true,
				dangerMode: true,
				})
				.then((willDelete) => {
					if (willDelete) {
						axios.post('api/paketjadwaldel', {
							id_paket: this.paket.id_paket,
							id_paket_jadwal: ref.id_paket_jadwal
						})
						.then(res => {
							this.lstjadwal.splice(index, 1);
							this.getAll();
							swal.fire("Jadwal berhasil dihapus!", {
								icon: "success",
							});
							
						})
						.catch(err => {
							// handle error
							console.log(err);
						})

						
					} else {
						swal("Jadwal gagal dihapus");
					}
				})

			
		},

		saveJadwal: function () {
            
            // this.paketjadwal.id_coach = localStorage.getItem('idUser');
            axios.post('api/paketjadwalinstructorupd', {
                    id_paket: this.paketjadwal.id_paket,
					paketjadwal: this.paketjadwal,
                })
                .then(res => {
					this.clearTbl("tbl");
                    this.getAll();
                    this.initDt("tbl");
                    $("#jadwalMdl").modal('hide');   
                    // handle success
					// this.getEditPaket(this.paket.id_paket);
					// this.isFormJadwal = false;
					// this.paketjadwal = [];
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		// deleteJadwal: function(index){
		// 	this.lstjadwal.splice(index, 1);
		// },
		
      
		getLdt: function(ref){            
			this.paketjadwal = ref;
			this.ldt =[];
			// this.paket = [];
			this.lstsoal = [];
			this.lstldtsiswa = [];
			this.clearTbl("tblLdt");
            this.initDt("tblLdt");
			this.getEditPaket(ref.id_paket);
            $("#ldtMdl").modal('show');
		},

		getLdtSiswa: function (ref) {
            this.paketjadwal = ref;
            $("#ldtMdl").modal('show');
            axios.get('api/ldtsiswabypaketjadwal/'+this.paketjadwal.id_paket+'/'+this.paketjadwal.id_paket_jadwal)
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblLdt");
                    this.lstldtsiswa = res.data.data;
                    this.initDt("tblLdt");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		
        getPreview: function (ref) {
            this.ldt = ref;
			this.lstsoal = []; 
            axios.get('api/ldtpreviewsoal/'+ref.id_user+'/'+ref.id_paket_sales+'/'+ref.id_paket_jadwal) //+this.$route.params.id)
                .then(res => {
                    $("#previewMdl").modal('show');

                    this.lstsoal = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		getJadwal: function (ref) {   
			this.paketjadwal = this.refpaketjadwal;
			this.isFormJadwal = false;
			this.clearTbl("tblJadwal");
			this.getEditPaket(ref.id_paket);
			this.initDt("tblJadwal");
			this.getAllTryoutJadwal();
			this.getAllCoach();
            $("#jadwalMdl").modal('show');
        },
 
		//--------------------------
		
		// GET Tryout
		getAllTryoutJadwal: function () {
            axios.get('api/tryoutinst')
                .then(res => {
                    this.lsttryoutjadwal = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		// GET Tryout
		getAllCoach: function () {
            axios.get('api/lstuserbyhakakses/2')
                .then(res => {
                    this.lstcoach = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },


    }
}
</script>


// WEBPACK FOOTER //
// src/components/Instructor/Penugasan/index.vue